import React from 'react'
import { Modal } from 'antd'

interface IConfirmationActionModal {
  title?: string
  okText?: string
  cancelText?: string
  content?: string | React.ReactNode
  onOk?: () => void
  onCancel?: () => void
}

const ConfirmationActionModal: React.FC<IConfirmationActionModal> = ({
  title = '',
  okText = 'Confirmar',
  cancelText = 'Cancelar',
  content = '',
  onOk = () => {},
  onCancel = () => {}
}) => {
  return (
    <Modal
      visible
      title={title}
      okText={okText}
      cancelText={cancelText}
      onOk={onOk}
      onCancel={onCancel}
    >
      {content}
    </Modal>
  )
}

export default ConfirmationActionModal
